import { createFileRoute, Navigate } from '@tanstack/react-router';
import { OperationsQuoteEditPage } from '@/features/operations/quote-edit-page';
import { createProtectedGuard } from '@/lib/route-guards';
import { useQuote } from '@/services/queries/quotes';

const adminOrOperationsGuard = createProtectedGuard({ roles: ['ADMIN', 'OPERATIONS'] });

export const Route = createFileRoute('/operations/quotes/$id/edit')({
  beforeLoad: adminOrOperationsGuard,
  component: OperationsEditQuoteRoute,
});

function OperationsEditQuoteRoute() {
  const { id } = Route.useParams();
  const { data: quote, isLoading, error, isFetched } = useQuote(id);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="flex items-center gap-3 text-slate-500">
          <span className="material-symbols-outlined animate-spin text-2xl">progress_activity</span>
          <span>Loading quote...</span>
        </div>
      </div>
    );
  }

  if (!isFetched) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="flex items-center gap-3 text-slate-500">
          <span className="material-symbols-outlined animate-spin text-2xl">progress_activity</span>
          <span>Loading quote...</span>
        </div>
      </div>
    );
  }

  if (error || !quote) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
          Quote Not Found
        </h2>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          The quote you're looking for doesn't exist or has been removed.
        </p>
      </div>
    );
  }

  // Only DRAFT quotes can be edited - redirect others to view page
  if (quote.status !== 'DRAFT') {
    return <Navigate to="/operations/quotes/$id" params={{ id }} />;
  }

  return <OperationsQuoteEditPage quote={quote} />;
}

